/* =========================================================
   MM Product Card - Slider images (grille produits)
   - Scroll-snap natif (swipe mobile fluide, zero instance par carte)
   - Navigation par INDEX (chaque clic = image suivante, fiable meme en pleine animation)
   - Survol desktop : revele la 2e image (comportement existant conserve)
   - Reinitialise les cartes ajoutees par l'infinite scroll (mm:products-loaded)
   ========================================================= */
(function () {
	'use strict';

	var SUPPORTS_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

	function initSlider(slider) {
		if (!slider || slider.dataset.mmSliderInit === '1') return;
		slider.dataset.mmSliderInit = '1';

		var track = slider.querySelector('[data-mm-track]');
		if (!track) return;
		var prev = slider.querySelector('[data-mm-arrow="prev"]');
		var next = slider.querySelector('[data-mm-arrow="next"]');
		var count = track.children.length;

		// Index logique : la source de verite pour la navigation par fleches.
		// Immunise contre les lectures de scrollLeft pendant une animation en cours.
		var index = 0;

		function slideWidth() {
			return track.clientWidth || (track.firstElementChild ? track.firstElementChild.clientWidth : 0);
		}

		function updateArrows() {
			if (prev) prev.classList.toggle('mm-pc-arrow-hidden', index <= 0);
			if (next) next.classList.toggle('mm-pc-arrow-hidden', index >= count - 1);
		}

		function goTo(i) {
			index = Math.max(0, Math.min(i, count - 1));
			track.scrollTo({ left: index * slideWidth(), behavior: 'smooth' });
			updateArrows();
		}

		if (prev) {
			prev.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(index - 1);
			});
		}
		if (next) {
			next.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(index + 1);
			});
		}

		// Apres un swipe (scroll utilisateur), on resynchronise l'index une fois le defilement stabilise.
		// Le debounce evite d'ecraser l'index pendant une rafale de clics ou une animation.
		var settle = null;
		track.addEventListener('scroll', function () {
			if (settle) clearTimeout(settle);
			settle = setTimeout(function () {
				var w = slideWidth();
				if (w) {
					index = Math.round(track.scrollLeft / w);
					updateArrows();
				}
			}, 90);
		}, { passive: true });

		// Survol desktop : revele la 2e image, comme le comportement actuel.
		if (SUPPORTS_HOVER) {
			var card = slider.closest('.mm-product-card');
			if (card) {
				card.addEventListener('mouseenter', function () {
					if (index === 0 && count > 1) goTo(1);
				});
				card.addEventListener('mouseleave', function () {
					goTo(0);
				});
			}
		}

		updateArrows();
	}

	function initAll(root) {
		var scope = (root && root.querySelectorAll) ? root : document;
		var sliders = scope.querySelectorAll('[data-mm-slider]');
		for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
	}

	function ready() {
		initAll(document);
	}

	if (!window.__mmCardSliderBound) {
		window.__mmCardSliderBound = true;
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', ready);
		} else {
			ready();
		}
		// Produits ajoutes via l'infinite scroll de la grille
		document.addEventListener('mm:products-loaded', function (e) {
			initAll(e && e.detail && e.detail.container ? e.detail.container : document);
		});
	} else {
		ready();
	}
})();
